let lenis = null;

export const setLenis = (instance) => {
    lenis = instance;
};

export const scrollToId = (id) => {
    const el = document.getElementById(id);
    if (!el) return;
    if (lenis) {
        lenis.scrollTo(el, { offset: -72, duration: 1.6 });
    } else {
        el.scrollIntoView({ behavior: "smooth" });
    }
};

export const WA_LINK =
    "https://wa.me/917709708074?text=" +
    encodeURIComponent(
        "Hi Prime 360 View, I want a quote for a 360° virtual tour for my business."
    );

export const GMB_MESSAGE =
    "I don't have a Google Business listing yet. Please create my Google Business Profile and add a 360° virtual tour to it.";

export const prefillQuote = (message) => {
    window.dispatchEvent(new CustomEvent("prefill-quote", { detail: message }));
    scrollToId("contact");
};

export const CONTACT = {
    phone: "+91 77097 08074",
    email: "info@prime360view.in",
    location: "Pune, Maharashtra",
};
